import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { createSettlementNote_providerFormZodObject } from "../create-settlement-note.provider-form";

const createSettlementNotesCommandZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("CREATE_SETTLEMENT_NOTES_COMMAND"),
    forms: z.array(createSettlementNote_providerFormZodObject),
});
type CreateSettlementNotesCommand = z.infer<
    typeof createSettlementNotesCommandZodObject
>;

type FactoryParams = Except<
    CreateSettlementNotesCommand,
    "_id" | "_type" | "_createdAt"
>;
const createSettlementNotesCommandFactory = (params: FactoryParams) => {
    const CreateSettlementNotesCommand: CreateSettlementNotesCommand = {
        ...params,
        _id: generateId({ prefix: "notes_command__" }),
        _type: "CREATE_SETTLEMENT_NOTES_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return CreateSettlementNotesCommand;
};

const createSettlementNotesCommandResponseZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("CREATE_SETTLEMENT_NOTES_COMMAND_RESPONSE"),
    jobRefs: z.array(
        z.object({
            providerId: providerIdZodSchema,
            jobId: z.string(),
            status: z.enum([
                "completed",
                "waiting",
                "active",
                "delayed",
                "failed",
                "paused",
            ]),
        }),
    ),
});

type CreateSettlementNotesCommandResponse = z.infer<
    typeof createSettlementNotesCommandResponseZodObject
>;

type ResponseFactoryParams = Except<
    CreateSettlementNotesCommandResponse,
    "_id" | "_type" | "_createdAt"
>;

const createSettlementNotesCommandResponseFactory = (
    params: ResponseFactoryParams,
) => {
    const CreateSettlementNotesCommandResponse: CreateSettlementNotesCommandResponse =
        {
            ...params,
            _id: generateId({ prefix: "notes_command_response__" }),
            _type: "CREATE_SETTLEMENT_NOTES_COMMAND_RESPONSE",
            _createdAt: nowIsoAndUnix(),
        };
    return CreateSettlementNotesCommandResponse;
};

export {
    createSettlementNotesCommandFactory,
    createSettlementNotesCommandResponseFactory,
    createSettlementNotesCommandResponseZodObject,
    createSettlementNotesCommandZodObject,
};
export type {
    CreateSettlementNotesCommand,
    CreateSettlementNotesCommandResponse,
};
